export const patientUploadResyncTargetKey = (mrn) =>
  mrn === undefined || mrn === null
    ? null
    : `patient-upload:${String(mrn)}`;

export default patientUploadResyncTargetKey;
